export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: 'include'
  });
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;
  if (!response.ok) {
    const error = payload?.error;
    throw new ApiError(response.status, error?.code || 'REQUEST_FAILED', error?.message || '请求失败', error?.details);
  }
  return payload as T;
}

export const getSession = () => api<import('./types').SessionPayload>('/api/me');
export const login = (username: string, password: string) =>
  api<{ user: import('./types').User }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  });
export const register = (username: string, password: string, inviteCode: string, displayName?: string) =>
  api<{ user: import('./types').User }>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ username, password, inviteCode, ...(displayName ? { displayName } : {}) })
  });
export const logout = () => api<{ ok: true }>('/api/auth/logout', { method: 'POST' });
export const validateInvite = (inviteCode: string) =>
  api<{ valid: boolean; amountCents: number }>('/api/auth/validate-invite', {
    method: 'POST',
    body: JSON.stringify({ inviteCode })
  });
